import {
  Component,
  HostListener,
  Inject,
  OnDestroy,
} from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { environment } from "../../../environments/environment";
import { ConfigService } from "../../core/services/config.service";

export interface RegistrationIframeDialogData {
  registrationUrl: string;
}

@Component({
  selector: "app-registration-iframe-dialog",
  templateUrl: "./registration-iframe-dialog.component.html",
  styleUrls: ["./registration-iframe-dialog.component.scss"],
})
export class RegistrationIframeDialogComponent implements OnDestroy {
  environment = environment;
  config;
  registrationIframeUrl: SafeResourceUrl | null = null;
  registrationIframeLoadFailed = false;
  private registrationIframeLoaded = false;
  private registrationIframeLoadTimer: ReturnType<typeof setTimeout> | null =
    null;

  constructor(
    public dialogRef: MatDialogRef<RegistrationIframeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RegistrationIframeDialogData,
    private sanitizer: DomSanitizer,
    private configService: ConfigService,
  ) {
    this.config = this.configService.config;
    this.registrationIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      data.registrationUrl,
    );
    this.clearRegistrationIframeTimer();
    this.registrationIframeLoadTimer = setTimeout(() => {
      if (!this.registrationIframeLoaded) {
        this.registrationIframeLoadFailed = true;
      }
      this.registrationIframeLoadTimer = null;
    }, 15000);
  }

  @HostListener("window:message", ["$event"])
  onRegistrationPostMessage(event: MessageEvent): void {
    if (!this.data?.registrationUrl) {
      return;
    }
    let expectedOrigin: string;
    try {
      expectedOrigin = new URL(this.data.registrationUrl).origin;
    } catch {
      return;
    }
    if (event.origin !== expectedOrigin) {
      return;
    }
    const d = event.data;
    if (!d || typeof d !== "object") {
      return;
    }
    if (
      (d as { type?: string }).type === "registration-complete" ||
      (d as { type?: string }).type === "registration-success" ||
      (d as { registrationComplete?: boolean }).registrationComplete === true
    ) {
      this.dialogRef.close();
    }
  }

  onRegistrationIframeLoad(): void {
    this.registrationIframeLoaded = true;
    this.registrationIframeLoadFailed = false;
    this.clearRegistrationIframeTimer();
  }

  close(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.clearRegistrationIframeTimer();
  }

  private clearRegistrationIframeTimer(): void {
    if (this.registrationIframeLoadTimer != null) {
      clearTimeout(this.registrationIframeLoadTimer);
      this.registrationIframeLoadTimer = null;
    }
  }
}
